"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight, Image as ImageIcon } from "lucide-react";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function PartsCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-64 animate-pulse rounded-lg bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6 text-center text-destructive">
        <p className="font-default">אירעה שגיאה בטעינת השירותים. אנא נסו שוב מאוחר יותר.</p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="text-center text-muted-foreground">
        <p className="font-default">לא נמצאו קטגוריות שירות כרגע.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {terms.map((term, i) => <div key={term.id} data-index={i} className="flex flex-col items-center rounded-lg border border-border bg-card p-8 text-center transition-all duration-300 hover:border-primary hover:shadow-md hover:shadow-primary/5">
          <div className="mb-6 flex h-20 w-20 items-center justify-center overflow-hidden rounded-lg bg-accent">
            {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover" loading="lazy" /> : <ImageIcon className="h-8 w-8 text-primary/40" />}
          </div>
          
          <h3 className="mb-3 text-2xl font-default tracking-tight text-card-foreground">
            {term.name}
          </h3>
          
          <p className="mb-6 flex-grow font-default text-sm text-muted-foreground">
            {term.description || `גלו את מגוון פתרונות הטיפול והסיוע המקצועיים שלנו עבור ${term.name.toLowerCase()} המותאמים אישית לצרכים שלכם.`}
          </p>
          
          <div className="flex flex-col gap-2">
            <Link to={term.link || "/"} className="group inline-flex items-center justify-center font-default text-sm font-semibold tracking-wide text-primary transition-colors hover:text-primary/80">
              למידע נוסף על {term.name}
              <ArrowRight className="mr-2 h-4 w-4 rotate-180 transition-transform group-hover:-translate-x-1" />
            </Link>
            
            <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 border-t border-border pt-4">
              <Link to="/NursingCaregiverInTelAvivWithinFiveHoursPage" className="font-default text-xs text-muted-foreground hover:text-primary">
                מטפל סיעודי בתל אביב
              </Link>
              <Link to="/" className="font-default text-xs text-muted-foreground hover:text-primary">
                מטפל סיעודי בבית
              </Link>
              <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="font-default text-xs text-muted-foreground hover:text-primary">
                השגחה בבית חולים
              </Link>
              <Link to="/BlogPage" className="font-default text-xs text-muted-foreground hover:text-primary">
                הבלוג שלנו
              </Link>
            </div>
          </div>
        </div>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 8,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function PartsCategories() {
  return <section data-section-id="259183" id="שירותים-סיעודיים" className="bg-background py-20 text-foreground">
      <div className="page-container">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-4xl font-default tracking-tight md:text-5xl">
            שירותים סיעודיים מקצועיים
          </h2>
          <p className="mx-auto max-w-2xl font-default text-muted-foreground">
            אנו מציעים מעטפת רחבה של שירותי סיעוד וטיפול ביתי, המוענקים על ידי צוות מיומן ומסור המותאם אישית לכל מטופל ומשפחה.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <PartsCategoriesConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}